import { GetStaticPropsContext, NextPage } from 'next'
import { GlobalProps, Layout, withLayoutProps } from 'slices/Layout'

import { BaseSeo } from '@/components/seo/BaseSeo'
import { REVALIDATION_FREQUENCY } from '@/shared/consts'
import { CreatorsHero, CreatorsPackages, CreatorsValueProps } from '@/slices/CreatorsPage'

export const getStaticProps = async (context: GetStaticPropsContext) =>
  withLayoutProps(context, {
    props: {},
    revalidate: REVALIDATION_FREQUENCY,
  })

type CreatorsPageProps = GlobalProps

const CreatorsPage: NextPage<CreatorsPageProps> = (layoutProps) => (
  <Layout {...layoutProps}>
    <BaseSeo
      title="Storybook Creation Tools for Artists & Freelancers — Pixie World"
      description="Pay once for the editor freelancers use to ship personalised storybooks at scale. Canva-style layouts, character consistency, 300 DPI print-ready exports. No subscriptions."
    />
    <CreatorsHero />
    <CreatorsValueProps />
    <CreatorsPackages />
  </Layout>
)

export default CreatorsPage
